import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import JobApplay from "../jobapplication/JobApplay";
import OptionSixSimilarJobs from "./OptionSixSimilarJobs";
import BackButton from "../../../../component/button/BackButton";

const OptionSixJobView = (props: any) => {
    const {
        routerLocation,
        routeParams,
        titleSection,
        jobLogo,
        ApplyNowButton,
        listOfPoint,
        description,
        imgAndVideo,
        positionFile,
        jobLocation,
        referenceNo,
        positionType,
        category,
        salary,
        postedOn,
        navigateToJob,
        similarJobList,
        clientSiteSettings,
    } = props;

    const { t } = useTranslation();
    const navigate = useNavigate();
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const optionSixTheme = cliendConfig?.data?.data?.clientSettings?.clientSiteSettings?.optionSixTheme;

    // by default showSimilarJobs is true
    const showSimilarJobs =
        clientSiteSettings?.showSimilarJobs !== undefined
            ? clientSiteSettings.showSimilarJobs
            : true;

    const isViewPage = useMemo(
        () => routerLocation.pathname === `/view/${routeParams?.id}`,
        [routerLocation.pathname, routeParams?.id]
    );

    // Apply form — only rendered on the apply route
    const applyForm = useMemo(
        () => (!isViewPage ? <JobApplay /> : null),
        [isViewPage]
    );

    const navigateToJobAlerts = () => navigate("/job-alerts");

    return (
        <div className={`option6-jobs option6-view-root${optionSixTheme === "light" ? " option6-jobs--light" : ""}`}>
            {/* ── Job detail view ── */}
            {isViewPage && (
                <div className="option6-shell">
                    <div className="opt6-view-back">
                        <BackButton />
                    </div>

                    <div className="opt6-view-layout">
                        {/* Left — main content */}
                        <div className="opt6-view-main">
                            {jobLogo && (
                                <div className="opt6-view-logo">{jobLogo()}</div>
                            )}
                            {titleSection()}
                            {positionFile && positionFile()}
                            {listOfPoint()}
                            {description()}
                            {imgAndVideo && imgAndVideo()}
                        </div>

                        {/* Right — sticky sidebar */}
                        <div className="opt6-view-sidebar">
                            <div className="opt6-view-meta-card">
                                <ApplyNowButton />
                                <div className="opt6-view-meta-list">
                                    {jobLocation()}
                                    {category()}
                                    {positionType()}
                                    {salary()}
                                    {referenceNo()}
                                    {postedOn()}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Similar jobs */}
                    {showSimilarJobs && similarJobList?.length > 0 && (
                        <OptionSixSimilarJobs
                            similarJobList={similarJobList}
                            navigateToJob={navigateToJob}
                        />
                    )}
                </div>
            )}

            {/* ── Apply form — wrapped in dark override ── */}
            {applyForm && (
                <div className="opt6-apply-wrap">
                    {applyForm}
                </div>
            )}
        </div>
    );
};

export default OptionSixJobView;
